import { ComponentInstall } from "../../utils";
import Menu from "./src";

export default ComponentInstall(Menu);
